export default __webpack_public_path__ + "static/bg-career-9fd1fca5b8f3673070c87d74aa7eacdf.jpeg";